import { QuestionMarkCircleIcon } from "@heroicons/react/outline";

import SelectSource, { SourceType } from "@/components/PowerBlock/Block/SourcesField/SelectSource";
import { useIsReadonly } from "@/components/PowerBlock/Block/readonly-context";
import { Toggle } from "@/components/Toggle";
import { BasicTooltip } from "@/components/ui/Tooltip";

interface ChatHistorySourceProps {
  enabled: boolean;
  source?: string;
  sources: Record<SourceType, string[]>;
  onToggle: (enabled: boolean) => void;
  onSourceChange: (source: string) => void;
}

const ChatHistorySource = ({
  enabled,
  source,
  sources,
  onToggle,
  onSourceChange,
}: ChatHistorySourceProps) => {
  const isReadonly = useIsReadonly();

  return (
    <div className="space-y-2">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-1">
          <span className="text-sm text-gray-700">Chat History</span>
          <BasicTooltip content="Inject chat history messages from a column into the prompt. Messages are appended at the end of the prompt template. The source column should contain a list of message objects with role and content fields.">
            <QuestionMarkCircleIcon className="h-4 w-4 text-gray-400" />
          </BasicTooltip>
        </div>
        <Toggle enabled={enabled} setEnabled={onToggle} disabled={isReadonly} />
      </div>
      {enabled && (
        <SelectSource
          value={source}
          sources={sources}
          onValueChange={onSourceChange}
          placeholder="Select chat history source"
          disabled={isReadonly}
        />
      )}
    </div>
  );
};

export default ChatHistorySource;
